export const GlobalConstants  = Object.freeze({
    badSSNSet:  new Set(["000000000", "111111111", "222222222", "333333333", "444444444", "555555555", "666666666", "777777777", "888888888", "999999999"]),
    statesWithAbbreviations: new Map([
        ['ALABAMA', 'AL'],
        ['ALASKA', 'AK'],
        ['AMERICAN SAMOA', 'AS'],
        ['ARIZONA', 'AZ'],
        ['ARKANSAS', 'AR'],
        ['ARMED FORCES AMERICAS', 'AA'],
        ['ARMED FORCES EUROPE', 'AE'],
        ['ARMED FORCES PACIFIC', 'AP'],
        ['CALIFORNIA', 'CA'],
        ['COLORADO', 'CO'],
        ['CONNECTICUT', 'CT'],
        ['DELAWARE', 'DE'],
        ['DISTRICT OF COLUMBIA', 'DC'],
        ['FLORIDA', 'FL'],
        ['GEORGIA', 'GA'],
        ['GUAM', 'GU'],
        ['HAWAII', 'HI'],
        ['IDAHO', 'ID'],
        ['ILLINOIS', 'IL'],
        ['INDIANA', 'IN'],
        ['IOWA', 'IA'],
        ['KANSAS', 'KS'],
        ['KENTUCKY', 'KY'],
        ['LOUISIANA', 'LA'],
        ['MAINE', 'ME'],
        ['MARSHALL ISLANDS', 'MH'],
        ['MARYLAND', 'MD'],
        ['MASSACHUSETTS', 'MA'],
        ['MICHIGAN', 'MI'],
        ['MINNESOTA', 'MN'],
        ['MISSISSIPPI', 'MS'],
        ['MISSOURI', 'MO'],
        ['MONTANA', 'MT'],
        ['NEBRASKA', 'NE'],
        ['NEVADA', 'NV'],
        ['NEW HAMPSHIRE', 'NH'],
        ['NEW JERSEY', 'NJ'],
        ['NEW MEXICO', 'NM'],
        ['NEW YORK', 'NY'],
        ['NORTH CAROLINA', 'NC'],
        ['NORTH DAKOTA', 'ND'],
        ['NORTHERN MARIANA ISLANDS', 'NP'],
        ['OHIO', 'OH'],
        ['OKLAHOMA', 'OK'],
        ['OREGON', 'OR'],
        ['PENNSYLVANIA', 'PA'],
        ['PUERTO RICO', 'PR'],
        ['RHODE ISLAND', 'RI'],
        ['SOUTH CAROLINA', 'SC'],
        ['SOUTH DAKOTA', 'SD'],
        ['TENNESSEE', 'TN'],
        ['TEXAS', 'TX'],
        ['US VIRGIN ISLANDS', 'VI'],
        ['UTAH', 'UT'],
        ['VERMONT', 'VT'],
        ['VIRGINIA', 'VA'],
        ['WASHINGTON', 'WA'],
        ['WEST VIRGINIA', 'WV'],
        ['WISCONSIN', 'WI'],
        ['WYOMING', 'WY'],
    ]),
    VBA_DB: new Array<any>(
        { label: "Test", id: "CoastalAdminTest" },
        { label: "Production", id: "CoastalAdmin" },
        { label: "QA", id: "CoastalAdminQA" }),
    Employer_Size: new Array<string>(
        "0-19 Employees",
        "20-99 Employees",
        "100+ Employees"),
    State_Abbreviations: new Array<string>(
        'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH',
        'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD',
        'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'),
    ReinsuranceContractReimburseMethods: new Array<any>(
        { label: "Spec. Advance Fund", id: "0" },
        { label: "Pay and Reimburse", id: "1" }
    ),
    DeleteAreas: new Array<any>(
        "Member",
        "Subscriber",
        "Group",
        "Division",
        "Plan",
        "Network",
        "Benefit",
        "Payee",
        "PremRate",
        "InvoiceAdjustment",
        //"Distribution",
        //"Funding Receipt",
        //"Account",
        //"Payment",
        //"Payor"
    ),
    ExtractAreas: new Array<any>(
        //"Member",
        //"Subscriber",
        //"Group",
        //"Division",
        //"Plan",
        //"Network",
        //"Benefit",
        //"Payee",
        "PremRate",
        //"InvoiceAdjustment",
        //"Distribution",
        //"Funding Receipt",
        //"Account",
        //"Payment",
        //"Payor"
    )
});